exports = module.exports = require("./../../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".affix{position:fixed;z-index:10}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/css-loader/0.23.1/css-loader!./~/.npminstall/postcss-loader/0.8.2/postcss-loader!./~/.npminstall/less-loader/2.2.3/less-loader!./src/components/Components/Affix/index.less
 ** module id = 501
 ** module chunks = 0
 **/